import { FormattedMessage } from "react-intl"
import { FormTextInput } from "@/components/Form/FormTextInput"
import { FormDatePicker } from "@/components/Form/FormDatePicker"
import { type TransportDetailsFormInput } from "./TransportDetailsPanel"
import { useWatch } from "react-hook-form"

export const UnloadingDetails = () => {
    const timeLoaded = useWatch({ name: `transportDetails.loading.loadedAt` })


    return <div
        className="display-flex gap-20 margin-bottom-15 align-items-center justify-content-center padding-20 bg-lightest">
        <div className="padding-x-20 text-center ">
            <span className="text-size-16 text-color-gray">
                <span className="rioglyph rioglyph-finish text-size-200pct">
                </span>
            </span>
        </div>
        <div className={"flex-basis-100pct"}>
            <FormDatePicker<TransportDetailsFormInput>
                fieldName={"transportDetails.unloading.unloadedAt"}
                label={<FormattedMessage id={"freightPaymentDetails.unloading.unloadedAt"}/>}
                required={true}
                allowTime={false}
                allowFutureDates={true}
                notBefore={timeLoaded}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.unloading.unloadedAt.required"}/>,
                    notBefore: <FormattedMessage id={"freightPaymentDetails.unloading.unloadedAt.notBeforeLoading"}/>,
                }}
            />
        </div>
        <div className={"flex-basis-100pct"}>
            <FormTextInput<TransportDetailsFormInput>
                fieldName={"transportDetails.unloading.duns"}
                label={<FormattedMessage id={"freightPaymentDetails.unloading.duns"}/>}
                required={true}
                mask={"000000000"}
                minLength={9}
                maxLength={9}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.unloading.duns.required"}/>
                }}
            />
        </div>
        <div className={"flex-basis-100pct"}>
            <FormTextInput<TransportDetailsFormInput>
                fieldName={"transportDetails.unloading.supplierCode"}
                label={<FormattedMessage id={"freightPaymentDetails.unloading.supplierCode"}/>}
                required={true}
                validationMessageOverrides={{
                    required: <FormattedMessage id={"freightPaymentDetails.unloading.supplierCode.required"}/>
                }}
            />
        </div>
    </div>
}
